import { store } from 'redux/store';
import { FC } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import sizes from 'constants/sizes';
import actionTypes from 'constants/actionTypes';

import AddCouncil from 'modules/_shared/components/Modals/AddCouncil';
import Button from 'modules/_shared/components/Buttons';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import { setModal } from 'modules/_shared/redux/modalActions';

import { BoardEntityTypes } from 'types/Board';
import { useGetBoardsListHeader } from './hooks/useGetBoardsListHeader';
import { boardEntityTypes } from './constants/boardEntityTypes';
import { AddBasicBoardModalProvider } from '../Modals/AddBasicBoard/context/AddBasicBoardModalContext';
import AddBasicBoardModal from '../Modals/AddBasicBoard';

type BoardsListHeaderProps = {
  boardType: BoardEntityTypes;
  viewType: string;
  boardsCount: number;
  onChangeView?: VoidFunction;
};

const BoardsListHeader: FC<BoardsListHeaderProps> = ({
  boardType,
  viewType,
  boardsCount,
  onChangeView,
}) => {
  const { t } = useTranslate();

  const isAdmin = useSelector((state: State) => state.society?.role?.isAdmin);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const {
    subtitleText,
    descriptionText,
    addBoardsButtonText,
    addBoardsButtonIcon,
  } = useGetBoardsListHeader({
    boardType,
    viewType,
    boardsCount,
  }).data;

  const description = `${actualSociety?.name || t('Society')} ${t(
    descriptionText,
    {
      count: boardsCount,
    }
  )}`;

  const handleAdd = () => {
    switch (boardType) {
      case boardEntityTypes.COUNCIL:
        store.dispatch(setModal(<AddCouncil action="ADD" size={sizes.XL} />));
        break;
      case boardEntityTypes.BOARD:
        break;
      case boardEntityTypes.BASIC_BOARD:
        store.dispatch(
          setModal(
            <AddBasicBoardModalProvider
              actionType={actionTypes.ADD}
              size={sizes.XL}
            >
              <AddBasicBoardModal />
            </AddBasicBoardModalProvider>
          )
        );
        break;
      default:
        break;
    }
  };

  return (
    <PageListHeader
      subTitle={t(subtitleText)}
      description={description}
      actions={
        isAdmin && [
          <Button onClick={handleAdd}>{t(addBoardsButtonText)}</Button>,
        ]
      }
    />
  );
};

export default BoardsListHeader;
